import React, { useState } from "react";
// import { Cesium1Set, RendouSet } from "../App";
// import { SyukurenSet } from "../App";
// import { Rotate1Set } from "../App";
// import { HeadingPitchRange } from "cesium";
import { Fullscreen } from "cesium";
// import { useEffect, useState } from "react";

export const ButtonFullscreen = (props) => {
  // const { setRotate1Set } = useContext(Rotate1Set);
  // const { setRendouSet } = useContext(RendouSet);
  // const { setSyukurenSet } = useContext(SyukurenSet);
  // const { cesium1set } = useContext(Cesium1Set);
  const [fullscre, setFullscre] = useState();

  let fullscr = () => {
    if (Fullscreen.fullscreen) {
      Fullscreen.exitFullscreen();
      setFullscre(false);
    } else {
      Fullscreen.requestFullscreen(document.body);
      setFullscre(true);
    }
  };

  return (
    <>
      <main className="flex items-center justify-center m-2">
        <div
          className="flex md:rounded-xl bg-gray-200 p-1 pointer-events-auto"
          // x-data="app"
          onClick={fullscr}
        >
          <label
            htmlFor="ホーム"
            className="block cursor-pointer select-none md:rounded-xl md:px-3 md:py-2 text-center text-xs md:text-base peer-checked:bg-blue-500 peer-checked:text-white"
          >
            <div className="z-10">
              {fullscre && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5l5.25 5.25"
                  />
                </svg>
              )}
              {!fullscre && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
                  />
                </svg>
              )}
            </div>
          </label>
        </div>
      </main>
    </>
  );
};
